"use client";

import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const FaireCircleIcon = createSVGIcon(
  <>
    <circle cx="30" cy="30" r="30" fill="#333" />
    <path
      d="m41.433 23.6-2.41-5.6H19.32v.333q.957.135 1.56.3.602.134 1.133.667.212.2.32.667.141.433.177 1 .07.565.07 1.2.036.633.036 1.233v8.433q0 1-.036 1.967 0 .933-.035 1.733V36.8q0 .534-.035 1.1-.036.534-.142 1.033a8 8 0 0 1-.177.9q-.107.367-.284.567-.495.534-1.276.833-.744.3-1.63.434V42h11.34v-.333q-1.452-.068-2.232-.3-.744-.267-1.063-.734-.32-.465-.426-1.4a51 51 0 0 1-.106-2.033q0-.567-.035-1.333V30h1.701q.354 0 .744.033.39 0 .922.034 1.027.066 1.771.366.78.267 1.454.834.744.633 1.275 1.833.532 1.167.816 2.233h.425V24.6h-.425q-.142.834-.32 1.567-.176.7-.602 1.3-.425.6-1.17 1.033t-2.02.7q-.495.1-1.24.167l-1.453.066q-.673.034-1.24.034h-.638V23.7q.035-1.4.07-2.567.036-.6.072-1 .035-.433.07-.7t.071-.466a2.5 2.5 0 0 0 .107-.4h.531q.39-.034.815-.034.426-.033.886-.033.461-.033.815-.033 2.091 0 3.65.2 1.595.165 2.198.433 1.24.567 2.552 1.767 1.31 1.2 2.764 2.9z"
      fill="#fff"
    />
  </>,
  "FaireCircleIcon",
  {
    viewBox: "0 0 60 60",
    titleAccess: "FaireCircleIcon",
    fill: "none",
    className: legacyIconCls(),
  }
);
